<template>
    <v-row class="mt-4">
        <v-col>
            <v-alert dismissible text shaped dense v-model="alert" border="left" :type="$props.type" class="text-left font-weight-bold" elevation="4" close-text="Close Alert" color="primary">
                {{ text }}
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>

export default {

    name: 'Alert',
    data() {
        return {
            alert: true,
        }
    },
    props: {
        type: {required: true},
        text: {required: true},
    }

}

</script>
